import React, { useEffect, useState } from "react";
import { TicketType } from "../types";
import { DropdownIcon } from "app/components/Icons";
import { useSelector } from "react-redux";
import { selectTicketTypes } from "app/redux/selector";
import { useDispatch } from "react-redux";
import { actions } from "../containers/Tickets/redux/slice";
import { actions as appAction } from "app/redux/slice";
import CommonTicketTypeSelection from "app/containers/Features/components/CommonTicketTypeSelection";

const AddTicketsDropdown = ({ setShowAddTask, open, setOpen }) => {
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState("");
  const ticketTypeOption = useSelector(selectTicketTypes);

  useEffect(() => {
    //Set default ticket type ID
    const defaultTicketType = ticketTypeOption.find((option) => option.icon === TicketType.TASK);
    if (defaultTicketType) {
      setSelectedValue(defaultTicketType?._id);
      dispatch(actions.setTicketFormValue({ name: "type", value: defaultTicketType?._id }));
    }
  }, []);

  const handleSelect = (icon: TicketType, id: string) => {
    dispatch(appAction.setStatusForSelectedTicketType({ ticketTypeId: id }));
    dispatch(actions.setTicketFormValue({ name: "type", value: id }));
    setSelectedValue(id);
    setShowAddTask({ show: true, type: icon });
  };

  const selectedType = ticketTypeOption.find((t) => t._id === selectedValue)?.icon;

  return (
    <CommonTicketTypeSelection
      setOpen={() => setOpen(!open)}
      trigger={
        <button
        className={`w-[20px] h-[20px] flex hover:bg-[#E9ECF2] justify-center items-center} ${open ? "rotate-180" : "rotate-270"}
        `}
      >
        <DropdownIcon size={20} />
      </button>
      }
      className="min-w-[237px]"
      dropDownClassName="py-0"
      align="start"
      showEndIcon
      showDefault
      isHeader="ticket types"
      value={selectedValue}
      isUnPaddedY={true}
      setValue={(data) => {
        handleSelect(data.icon as TicketType, data._id);
      }}
    />
  );
};

export default AddTicketsDropdown;
